import React, { useState } from "react";
import { UiButton } from "../../components/form/UiButton";
import { UiFormFooter } from "../../components/common/UiFormFooter";
import { UiCheckboxInput, UiInput, UiInputLink } from "../../components/form/UiInput";
import { UiModal } from "../../components/common/UiModal";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import GoBack from "../../../../styles/img/go-back-icon.png"

export const SignUpPageStepTwo = () => {

    return (
        <>
            <UiModal>
                <div className="sb-signup-page__go-back">
                    <p>Go Back </p>
                </div>
                <div className="sb-signup-page__step-two">
                    <img src={GoBack} />
                    <h3>Sign Up</h3>
                </div>
                <div className="sb-signup-page__create-username">
                    <p>Please Create Username </p>
                </div>

                <UiSingleRow>
                    <UiCol lg="12">
                        <UiInput
                            label="Enter User Name"
                            placeholder="User Name"
                            type="text"
                        />
                    </UiCol>
                    <UiCol lg="12">
                        <p>Based on your information we suggest</p>
                        <ul>
                            <li>Rickjoney</li>
                            <li>Rickjoney</li>
                        </ul>
                    </UiCol>




                    <UiCol lg="12">
                        <UiCheckboxInput
                            label=""
                            type="checkbox"
                            for="terms"
                            name="terms"
                            id="terms"
                            link="Terms of Service 
                                        and Privacy Policy"
                            to="/"
                            linkLabel="I’ve read and accepted "
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiButton
                            className="sb-main-primary-button sb-submit-button"
                            title="Activate Account"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiFormFooter
                            text="Already have an account?"
                            link="/login"
                            linkText="Sign In"
                        />
                    </UiCol>

                </UiSingleRow>

            </UiModal>


        </>
    )
}